package com.essntl.core.whatsapp.data.di

import com.essntl.core.whatsapp.data.WhatsappClientImpl
import com.essntl.core.whatsapp.domain.WhatsappClient
import org.koin.dsl.module

val whatsappModule
    get() =
        module {
            single<WhatsappClient> {
                WhatsappClientImpl(
                    httpClient = get(),
                )
            }
        }
